const requiredListValidator = value => {
  if (!value || !Array.isArray(value) || !value.length) {
    return 'Required';
  }
  return undefined;
};

export default requiredListValidator;
